import script from "./details.vue?vue&type=script&lang=ts&setup=true"
export * from "./details.vue?vue&type=script&lang=ts&setup=true"

import "./details.vue?vue&type=style&index=0&id=430cd6fa&lang=scss&scoped=true"

import exportComponent from "D:\\yuntian\\eso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430cd6fa"]])

export default __exports__